import { kanoonRoutes } from "./kanoon-routes";

export default (router: any) => {
  kanoonRoutes.forEach((route: any) => {
    router.addRoute(route);
  });
};
